module.exports = __webpack_public_path__ + "static/media/arrow-left.14fd753f.svg";